import { createContext, useContext, useEffect, useState } from 'react';
import api from '../lib/api';

const NavigationContext = createContext({ config: null, reload: () => {} });

export const NavigationProvider = ({ children }) => {
  const [config, setConfig] = useState(null);

  const reload = () => api.get('/navigation').then(r => setConfig(r.data)).catch(() => {});
  useEffect(() => { reload(); }, []);

  return (
    <NavigationContext.Provider value={{ config, reload }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => useContext(NavigationContext);
